<template>
  <!-- 非码商才出现 -->
  <dir>
    <span
      v-show="stickyObj.hideTab"
      @click="
        stickyObj.hideTab = false;
        syncSticky();
      "
      class="hide-tab"
    >
      <svg-icon icon-class="th-notebook"></svg-icon>
    </span>
    <div
      v-show="!stickyObj.hideTab"
      id="sticky-note"
      @mouseover="StickyMouseover"
      @mouseleave="StickyMouseleave"
      class="note-main drag-area"
    >
      <ul class="note-cards">
        <li class="note-cards_item">
          <div class="note-card">
            <div class="note-card_content">
              <!-- 拖曳 icon -->
              <span class="wrap-drag" @mousedown="mousedown">
                <svg-icon
                  icon-class="th-handgrabbing"
                  class="th-handgrabbing"
                ></svg-icon>
              </span>
              <!-- 小飞机 icon -->
              <span
                style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  z-index: 1000;
                  cursor: pointer;
                  color: #bbadab;
                "
                @click="
                  stickyObj.hideTab = true;
                  syncSticky();
                "
              >
                <svg-icon
                  icon-class="th-telegramlogo"
                  class="th-telegramlogo"
                ></svg-icon>
              </span>
              <!-- 保存 icon -->
              <span @click="syncSticky()">
                <svg-icon
                  v-if="NoteUpdated"
                  icon-class="th-floppydisk"
                  class="th-floppydisk"
                ></svg-icon>
                <svg-icon
                  v-else
                  style="cursor: pointer; color: #4f4f4f"
                  icon-class="th-floppydisk"
                  class="th-floppydisk"
                ></svg-icon>
              </span>

              <!--码商 switch -->
              <template
                v-if="
                  ['customer'].indexOf(userInfo.userType) !== -1 &&
                  userInfo.commonUserType === 3
                "
              >
                <div style="text-align: center">
                  <el-switch
                    :disabled="switchDisabled"
                    @change="toggleOnlineStatus($event)"
                    v-bind:class="{ switchLoading }"
                    style="margin-top: -45px"
                    v-model="onlineStatus"
                    active-color="#409EFF"
                    inactive-color="#ff0000"
                    active-text="在线"
                    inactive-text="下线"
                  />
                </div>
              </template>

              <!-- 放大缩小 icon -->
              <span @click="StickyToggle()" class="wrap-exit-fullscreen">
                <svg-icon
                  :icon-class="
                    stickyObj.minMode ? 'fullscreen' : 'exit-fullscreen'
                  "
                  class="exit-fullscreen"
                ></svg-icon>
              </span>
              <!-- <h2 class="card_title">Jed Memo</h2> -->
              <!-- th-lockkey -->
              <div class="note-card_text">
                <span
                  v-if="
                    !(
                      ['customer'].indexOf(userInfo.userType) !== -1 &&
                      userInfo.commonUserType === 3
                    )
                  "
                >
                  <h2>停止收单时段：</h2>
                  <template
                    v-if="
                      periodsOfSystemClosed &&
                      periodsOfSystemClosed.length === 1 &&
                      periodsOfSystemClosed[0] === '00:00:00-00:00:00'
                    "
                    ><p class="green">全时段收单</p></template
                  >
                  <template v-else>
                    <p v-for="item in periodsOfSystemClosed" :key="item">
                      {{ item }}
                    </p>
                  </template>
                  <!-- 管理员、凭证审核员展示线上审核员列表 -->
                  <template
                    v-if="
                      ['credential_auditor', 'admin'].indexOf(
                        userInfo.userType
                      ) !== -1 &&
                      credentialAuditorResults &&
                      credentialAuditorResults.length > 0
                    "
                  >
                    <p
                      class="credential-auditor"
                      v-for="item in credentialAuditorResults"
                      :key="item.userName"
                    >
                      审核员：{{ item.userName }} 处理中订单数：{{
                        item.dispatchOrders
                      }}
                    </p>
                  </template>
                </span>
                <textarea
                  v-show="!stickyObj.minMode"
                  v-model="stickyObj.Note"
                  id="textarea-data"
                  rows="15"
                  placeholder="记事本请勿留存重要信息..."
                  @input="NoteUpdated = false"
                ></textarea>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </dir>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { updateCustomerOnlineStatus } from "@/api/user";
export default {
  mixins: [mainCommon],
  data() {
    return {
      stickyObj: {
        hideTab: false,
        minMode: true,
        Note: "",
        mouseOver: false,
        positionLeft: null,
        positionTop: null,
      },
      NoteUpdated: true, // 一开始没有资料或是 localStorage 有资料，都应该在一开始是同步的
      onlineStatus: null, // 上下线
      credentialAuditorResults: [], // 线上审核员
      periodsOfSystemClosed: [], // 停止收单时段
      dispatchOrdersCnt: 0, // 卡主仍在处理中的订单数
      receiptOperateOrdersCnt: 0, // 仍等待审核回单的订单数
      switchDisabled: false, // switch disabled
      switchLoading: false, // switch loading
      workOffDialogVisible: false, // 转移警告弹框
    };
  },
  watch: {
    "$store.state.app.unallocatedObj.credentialAuditorResults"(val) {
      this.credentialAuditorResults = val;
    },
    "$store.state.app.unallocatedObj.userOnlineStatus"(val) {
      this.onlineStatus = val;
    },
    // 停止收单时段
    "$store.state.app.unallocatedObj.periodsOfSystemClosed"(val) {
      this.periodsOfSystemClosed = val;
    },
  },
  mounted() {
    // 获取有储存过的资料
    let stickyObj = localStorage.getItem(`sticky-${this.userInfo.userId}`)
      ? JSON.parse(localStorage.getItem(`sticky-${this.userInfo.userId}`))
      : "";
    if (stickyObj && stickyObj.positionLeft && stickyObj.positionTop) {
      this.stickyObj = stickyObj;
      document
        .getElementById("sticky-note")
        .setAttribute(
          "style",
          `left: ${stickyObj.positionLeft};top: ${stickyObj.positionTop};bottom: auto;`
        );
    } else if (stickyObj && stickyObj.hideTab) {
      this.stickyObj = stickyObj;
      document
        .getElementById("sticky-note")
        .setAttribute("style", `left: 6px;bottom: 6px;`);
    }
    /* 避免打包会把记事本样式 transparent 后面的 0 给移除，这里直接用 js 来写入 */
    document.querySelector(".note-card").setAttribute(
      "style",
      `background:repeating-linear-gradient( transparent 0 calc(1.2rem - 1px), #66afe1 0 1.2rem )100% 100%/100% 100%, linear-gradient(red 0 0) 30px 0/2px 100% #fff;
        -webkit-mask: radial-gradient(circle 0.8rem at 2px 50%, #0000 98%, #000) 0 0/100% 2.4rem;
        background-repeat: no-repeat;`
    );
  },
  methods: {
    // 滑鼠进入
    StickyMouseover() {
      this.stickyObj.mouseOver = true;
    },
    // 滑鼠离开
    StickyMouseleave() {
      this.stickyObj.mouseOver = false;
      this.syncSticky();
    },
    // 切换便签
    StickyToggle() {
      this.stickyObj.minMode = !this.stickyObj.minMode;
      this.syncSticky();
    },
    // 开始抓位置
    mousedown(event) {
      this.selectElement = document.getElementById("sticky-note");
      var div1 = this.selectElement;
      this.selectElement.style.cursor = "move";
      var distanceX = event.clientX - this.selectElement.offsetLeft;
      var distanceY = event.clientY - this.selectElement.offsetTop;
      document.onmousemove = (ev) => {
        var oevent = ev || event;
        div1.style.left = oevent.clientX - distanceX + "px";
        div1.style.top = oevent.clientY - distanceY + "px";

        this.selectElement.style.bottom = "auto";
        this.stickyObj.positionLeft = div1.style.left;
        this.stickyObj.positionTop = div1.style.top;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        div1.style.cursor = "default";
      };
      this.NoteUpdated = false;
    },
    // 同步资讯到 localStorage
    syncSticky() {
      localStorage.setItem(
        `sticky-${this.userInfo.userId}`,
        JSON.stringify(this.stickyObj)
      );
      this.NoteUpdated = true;
    },
    toggleOnlineStatus($event) {
      this.onlineStatus = $event;
      this.changeOnlineStatus($event);
    },
    // 切换 onlineStatus 状态
    changeOnlineStatus(onlineStatus) {
      this.switchDisabled = true;
      this.switchLoading = true;

      // 码商
      updateCustomerOnlineStatus({
        onlineStatus,
        userId: this.userInfo.userId,
      })
        .then(() => {})
        .catch(() => {
          setTimeout(() => {
            this.onlineStatus = !onlineStatus;
          }, 1000);
        })
        .finally(() => {
          this.$store.dispatch("GetUnallocatedAll"); // 打一次小红点接口为同步
          setTimeout(() => {
            this.switchDisabled = false;
            this.switchLoading = false;
          }, 1000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-tab {
  position: fixed;
  bottom: 0;
  z-index: 2000;
  left: 0;
  background-color: #fff;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 0 6px 0 0;
  overflow: hidden;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.25));
  transition: all 0.1s;
  text-align: center;
  cursor: pointer;
}
.hide-tab:hover {
  width: 50px;
  height: 50px;
  line-height: 50px;
}
#sticky-note.note-main {
  position: fixed;
  z-index: 20000;
  left: 6px;
  bottom: 6px;
}
#sticky-note .note-card_text p.credential-auditor {
  color: #68a841;
}
#sticky-note #textarea-data {
  border: none;
  outline: 0;
  background-color: transparent;
  width: 100%;
  line-height: 1.2rem;
  font-size: 16px;
  resize: none;
  overflow-y: hidden;
  padding: 0;
  margin-top: 1.2rem;
}
#sticky-note .note-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
}

#sticky-note .note-cards_item {
  display: flex;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.25));
}

#sticky-note .note-card {
  width: 100%;
  min-width: 200px;
  background-color: white;
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 30px;
  line-height: 1.2rem;
}

#sticky-note .note-card_content {
  padding: 0 1.2rem 2.4rem;
  position: relative;
}
#sticky-note .wrap-drag {
  width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 10px;
  text-align: center;
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
#sticky-note .wrap-drag:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

#sticky-note.note-main h2,
#sticky-note.note-main p {
  margin: 0;
}
#sticky-note.note-main h2 {
  font-size: 16px;
  font-weight: 500;
}
#sticky-note .note-card_text p {
  color: #ff9898;
  letter-spacing: 1.7px;
  font-weight: 600;
}
#sticky-note .th-floppydisk {
  color: #b5b5b5;
  height: 40px;
  vertical-align: top;
  width: 25px;
  position: relative;
}
#sticky-note .th-handgrabbing {
  color: #e9e9e9;
  height: 40px;
  vertical-align: top;
  width: 25px;
}
#sticky-note .wrap-drag:hover .th-handgrabbing {
  color: #868686;
}
#sticky-note .wrap-exit-fullscreen {
  position: absolute;
  right: 10px;
  bottom: 0;
  cursor: pointer;
}
#sticky-note .exit-fullscreen {
  color: #868686;
  height: 40px;
  vertical-align: top;
  width: 18px;
}
#sticky-note .note-card_text p.green {
  font-size: 16px;
  color: #67c23a;
  font-weight: 600;
  width: 100%;
  display: inline-block;
  text-align: center;
  letter-spacing: 1.7px;
  text-shadow: -0.4px 0.6px 0px #000;
}
.hide-tab:hover {
  animation: shake 150ms infinite;
  -moz-animation: shake 150ms infinite;
  -webkit-animation: shake 150ms infinite;
  -o-animation: shake 150ms infinite;
}
@keyframes shake {
  0% {
    transform: translate(3px, 3px);
  }
  50% {
    transform: translate(-3px, -3px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/OnlineOrderNote.vue